import i18n from '@/plugins/i18n';

const bucketCBGraphs = () => ({
  lineCharts: [
    {
      width: '49%',
      title: i18n.global.t('dbm.bucket-ops'),
      header: {
        title: i18n.global.t('dbm.bucket-ops'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#fdfcac'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_couchbase_buckets_bucket_ops',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.bucket-operations'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.bucket-operations'),
      },
    },
    {
      width: '49%',
      title: i18n.global.t('dbm.disk-used'),
      header: {
        title: i18n.global.t('dbm.disk-used'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_couchbase_buckets_bucket_disk_usage',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.disk-used-mb'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.disk-used-mb'),
      },
      aggregation: '/',
      aggregationNum: '1048576',
    },
    {
      width: '49%',
      title: i18n.global.t('dbm.mem-used'),
      header: {
        title: i18n.global.t('dbm.mem-used'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#29eeca'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_couchbase_buckets_bucket_mem_usage',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.mem-used-mb'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.mem-used-mb'),
      },
      aggregation: '/',
      aggregationNum: '1048576',
    },
    {
      width: '49%',
      title: i18n.global.t('dbm.current-items'),
      header: {
        title: i18n.global.t('dbm.current-items'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#9bb6ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_couchbase_buckets_bucket_current_items',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.number-of-items'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.number-of-items'),
      },
    },
  ],
});
export default bucketCBGraphs;
